import EthImg from "./Eth.png";

export const EthIcon = () => (
  <image
    href={EthImg}
    x="0"
    y="0"
    width="24"
    height="24"
    preserveAspectRatio="xMidYMid meet"
  />
);
